<div class="pickup-box">
  <div class="product-info">
    <div class="col-xxl-12 col-xl-12 col-lg-12 d-flex flex-column gap-3">
      <div class="d-md-none d-lg-none d-xl-none d-xxl-none">
        <ng-container *ngIf="isAuthenticated">
          <div
            *ngIf="product.stockStatus < 8 && product.basePrice > 0"
            class="cart_qty qty-box product-qty mt-0 w-100 d-flex flex-column gap-3"
          >
            <span class="input-group">
              <app-counter
                *ngIf="product.cartItem"
                [cartItem]="product.cartItem"
                style="width: 100%"
                [btnClass]="'btn-counter'"
              ></app-counter>
            </span>
            <div
              class="d-flex justify-content-between p-2"
              style="border-top: 1px solid #f2f2f7; border-bottom: 1px solid #f2f2f7;"
              *ngIf="productPolicy && productPolicy.length > 0">
              <div
                class="d-flex align-items-center justify-content-center"
                style="position: relative; flex: 1;"
                [class.has-border]="i < productPolicy.length - 1"
                [ngStyle]="{'cursor': item.direction ? 'pointer' : 'default'}"
                *ngFor="let item of productPolicy; let i = index"
                (click)="gotoPolicy(item)" data-cta="product.policy" data-cta-loc="product_detail"
              >
                <div class="d-flex align-items-center gap-1 flex-column p-2">
                  <img
                    *ngIf="item.iconUrl"
                    [src]="item.iconUrl"
                    [alt]="item.description"
                    width="24"
                    height="24"
                   loading="lazy" />
                  <div class="text-center" style="color: #242424; font-weight: 600; white-space: pre-wrap;">{{ item.description }}</div>
                </div>
              </div>
            </div>
            <div
              *ngIf="
                product.productOrderLimit?.maxOrderQuantityPerOrder ?? 0 > 0
              "
              style="text-align: center"
            >
              <h6>
                Tối đa
                {{ product.productOrderLimit.maxOrderQuantityPerOrder }} SP/đơn
              </h6>
            </div>
            <div
              *ngIf="product.productOrderLimit?.maxOrderQuantityPerDay ?? 0 > 0"
              style="text-align: center"
            >
              <h6>
                Tối đa
                {{ product.productOrderLimit.maxOrderQuantityPerDay }} SP/ngày
              </h6>
            </div>
          </div>
        </ng-container>
      </div>

      <ng-template #warning>
        <div>
          <ng-container *ngIf="!product.warningStatus || product.warningStatus === ''">
            <div class="out-of-stock-label" *ngIf="product.basePrice <= 0">
              <h5
                *ngIf="product.stockStatus != 8"
                class="out-of-stock-text"
                style="color: #CF1322"
              >
                Sản phẩm tạm thời hết hàng
              </h5>
              <a routerLink="/account/my-business-profile">
                <h5
                  *ngIf="product.stockStatus == 8"
                  class="out-of-stock-text"
                  style="color: #CF1322"
                >
                  Xác minh hồ sơ KD để xem giá
                </h5>
              </a>
            </div>
            <div class="out-of-stock-label" *ngIf="product.basePrice > 0">
              <a routerLink="/account/my-business-profile">
                <h5
                  *ngIf="product.stockStatus == 9"
                  class="out-of-stock-text"
                  style="color: #CF1322"
                >
                  Xác minh hồ sơ KD để đặt hàng
                </h5>
                <h5
                  *ngIf="product.stockStatus == 10"
                  class="out-of-stock-text"
                  style="color: #CF1322"
                >
                  Không thuộc phạm vi KD
                </h5>
              </a>
            </div>
          </ng-container>

          <ng-container *ngIf="product.warningStatus && product.warningStatus !== ''">
            <a [routerLink]="product.stockStatus !== 0 ? '/account/my-business-profile': null">
              <h5
                class="out-of-stock-text"
                style="color: #CF1322"
              >
                {{ product.warningStatus }}
              </h5>
            </a>
          </ng-container>
        </div>
      </ng-template>

      <ng-container *ngFor="let info of product.productInfo">
        <div class="row row-cols-2 product-list-section" *ngIf="info.display && info.type !== 1 && info.type !== 2">
          <div class="col-xl-3 product-info-label">
            <span>{{ info.name }}</span>
          </div>
          <div class="col-xl-9 product-info-content">
            <span *ngIf="info.path; else value">
              <button
                class="border-0 bg-transparent theme-color p-0 text-start"
                (click)="goto(info.path)" data-cta="product.info_link" data-cta-loc="product_detail"
              >
                {{ info.value }}
              </button>
            </span>
            <ng-template #value>
              <span>{{ info.value || "Đang cập nhật" }}</span>
            </ng-template>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="product.expiredDate">
        <div class="row row-cols-2 product-list-section align-items-center">
          <div class="col-xl-3 product-info-label">
            <span>Hạn sử dụng</span>
          </div>
          <div class="col-xl-9 product-info-content">
            <div style="padding-top: 5px">
              <div class="product-label expired tag-label">
                <span class="m-0">{{ product.expiredDate }}</span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- <div *ngIf="productVouchers.length > 0" class="row align-items-center">
        <div class="col-3">
          <span style="color: #4a4f63">Mã giảm giá có thể dùng:</span>
        </div>
        <div class="col-9 d-flex flex-wrap gap-2">
          <div *ngFor="let voucher of productVouchers.slice(0,3)" class="relevant-voucher" (click)="openVoucherModal(productVouchers, voucher.code)" style="cursor: pointer">
            {{ voucher.code }}
          </div>
        </div>
      </div> -->

      <!-- <div style="width: 218px;" class="mobile-w-100" (click)="gotoBlog()">
        <app-button-combo></app-button-combo>
      </div> -->

      <div class="d-md-none">
        <app-banner-policy [banners]="productBanner"></app-banner-policy>
      </div>

      <ng-container *ngIf="productSuggestions && productSuggestions.length > 0">
        <div class="product-suggestion-containter">
          <div
            style="
              font-size: 20px;
              font-weight: 700;
              line-height: 100%;
              letter-spacing: 0.6px;
              color: var(--theme-color);
            "
          >
            Sản phẩm gợi ý
          </div>
          <div
            *ngFor="
              let productSuggestion of productSuggestions;
              let last = last
            "
            class="d-flex flex-column gap-3"
          >
            <app-product-suggestion
              [productSuggestion]="productSuggestion"
              [vouchers]="vouchers"
              [isAuthenticated]="isAuthenticated"
            ></app-product-suggestion>
            <div *ngIf="!last" class="divider"></div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<!-- <app-login-modal #loginModal (openRegistryModal)="openRegistryModal($event)"
  (openForgotPasswordModal)="openForgotPasswordModal($event)"></app-login-modal>
<app-registry-modal-v2 #registryModal (openLoginModal)="openLoginModal($event)"></app-registry-modal-v2>
<app-forgot-password-modal #forgotPasswordModal
  (openRegistryModal)="openRegistryModal($event)"></app-forgot-password-modal> -->

<app-voucher-modal
  #voucherModal
  [cart]="cart"
  [isInCartPage]="false"
  [selectedCode]="selectedVoucherCode"
></app-voucher-modal>
